/**
 * Utilitário para limpar dados de autenticação corrompidos
 *
 * NOTA IMPORTANTE: Esta função foi DESABILITADA porque:
 * 1. Os dados agora são armazenados via authStorage com criptografia AES-GCM
 * 2. As chaves têm prefixo appagenda_ e formato criptografado
 * 3. Não podemos validar dados criptografados sem descriptografá-los
 * 4. A validação JWT direta não funciona em dados criptografados
 * 5. O authStorage já tem validação de expiração integrada
 */

export const cleanupCorruptedAuth = () => {
  // Função desabilitada - authStorage cuida da validação
  console.log('[cleanupAuth] Função desabilitada - authStorage gerencia validação automaticamente');
  return false;
};

/**
 * Verifica se há tokens muito antigos (mais de 24h) e limpa
 *
 * NOTA: Função desabilitada - authStorage já gerencia expiração automaticamente
 */
export const cleanupOldTokens = () => {
  // Função desabilitada - authStorage cuida da expiração
  console.log('[cleanupOldTokens] Função desabilitada - authStorage gerencia expiração automaticamente');
  return false;
};